import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  debugActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.debugActive$.next(this.loadDebugState());
  }

  public setDebugState(state: boolean) {
    this.debugActive$.next(state);
    this.saveDebugState(state);
  }

  public loadDebugState(): boolean {
    return localStorage.getItem('debug') === 'true';
  }

  public saveDebugState(state: boolean) {
    return localStorage.setItem('debug', JSON.stringify(state));
  }
}
